export class Installmentchange {

    Id                                           :number; 
    LoanId                                       :number; 
    InstallmentChangeDate                        :string; 
    InstallmentAmount                            :number; 
    InstallmentOption                            :number ; 
    EmployeeId                                   :number; 
    EmployeeBranchId                             :number; 
    CompanyId                                    :number; 
    SaasId                                       :number; 
    // CreatedDate                                  :null; 
    // ModifiedDate                                 :null; 
    IsActive                                     :boolean; 
    Flag                                         :number;
}
